// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3SLsl","large":"styles_large__32QyR"};